import type { RootState } from "@/services/store";
import { widgetsAdapter } from "./state";

export const allWidgetsSelector = widgetsAdapter.getSelectors<RootState>(
  (state) => state.widgets,
).selectAll;

export const allLayoutsSelector = (state: RootState) => state.layouts.layouts;

export const currentLayoutsSelector = (state: RootState) => state.layouts.currentLayouts;
